export default (ra) => ({
  async declared({ category, source }) {
    await ra.track("Attribution Declared", {
      attribution_category: category,
      attribution_source: source,
    })
  },
})
